import React from 'react';
import { Activity } from '@bingads-webui-react/hoc-with-signal';
import { AssetsStepShell, AssetsStepSettingsShell, useAssetsStepRepository } from '@bingads-webui-campaign-react/unified-app-assets';
import { TargetingStepShell, useTargetingStepRepository } from '@bingads-webui-campaign-react/unified-app-targeting';
import { CampaignDetailsStepShell, CampaignDetailsEditStepShell, useCampaignDetailsStepRepository, useCampaignDetailsEditStepRepository } from '@bingads-webui-campaign-react/unified-app-campaign-details';
import { BudgetStepShell, useBudgetStepRepository } from '@bingads-webui-campaign-react/unified-app-budget';
import { SummaryStepShell, useSummaryStepRepository } from '@bingads-webui-campaign-react/unified-app-summary';

import { STEP_PATHS } from './step-constants';

export const UnifiedAppCampaignStepsConfig = [
  {
    id: STEP_PATHS.ASSETS,
    view: props => <Activity name={STEP_PATHS.ASSETS}> <AssetsStepShell {...props} /> </Activity>,
    repository: useAssetsStepRepository,
  },
  {
    id: STEP_PATHS.TARGETING,
    view: props => <Activity name={STEP_PATHS.TARGETING}> <TargetingStepShell {...props} /> </Activity>,
    repository: useTargetingStepRepository,
  },
  {
    id: STEP_PATHS.CAMPAIGN_DETAILS,
    view: props => <Activity name={STEP_PATHS.CAMPAIGN_DETAILS}> <CampaignDetailsStepShell {...props} /> </Activity>,
    repository: useCampaignDetailsStepRepository,
  },
  {
    id: STEP_PATHS.BUDGET,
    view: props => <Activity name={STEP_PATHS.BUDGET}> <BudgetStepShell {...props} /> </Activity>,
    repository: useBudgetStepRepository,
  },
  {
    id: STEP_PATHS.SUMMARY,
    view: props => <Activity name={STEP_PATHS.SUMMARY}> <SummaryStepShell {...props} /> </Activity>,
    repository: useSummaryStepRepository,
  },
];

export const UnifiedAppEditCampaignSettingsStepsConfig = [
  {
    id: STEP_PATHS.CAMPAIGN_DETAILS_EDIT,
    view: props => <Activity name={STEP_PATHS.CAMPAIGN_DETAILS_EDIT}> <CampaignDetailsEditStepShell {...props} /> </Activity>,
    repository: useCampaignDetailsEditStepRepository,
  },
];

export const UnifiedAppEditAssetGroupSettingsStepConfig = [
  {
    id: STEP_PATHS.ASSETS_GROUP_EDIT,
    view: props => <Activity name={STEP_PATHS.ASSETS_GROUP_EDIT}> <AssetsStepSettingsShell {...props} /> </Activity>,
    repository: useAssetsStepRepository,
  },
];

export const getStepListConfig = ({ i18n }) => {
  const stepListConfig = [{
    id: STEP_PATHS.ASSETS,
    title: i18n.getString(_TL_('Assets')),
  }, {
    id: STEP_PATHS.TARGETING,
    title: i18n.getString(_TL_('Targeting')),
  }, {
    id: STEP_PATHS.CAMPAIGN_DETAILS,
    title: i18n.getString(_TL_('Campaign details')),
  }, {
    id: STEP_PATHS.BUDGET,
    title: i18n.getString(_TL_('Budget')),
  }, {
    id: STEP_PATHS.SUMMARY,
    title: i18n.getString(_TL_('Summary')),
  }];

  return stepListConfig;
};
